var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/elements/plusminusinput.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["col", "columnIndex", "index", "colval", "minNumber", "maxNumber", "classes"], 
[], 
function (l_col, l_columnIndex, l_index, l_colval, l_minNumber, l_maxNumber, l_classes, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("col", l_col);
frame.set("columnIndex", l_columnIndex);
frame.set("index", l_index);
frame.set("colval", l_colval);
frame.set("minNumber", l_minNumber);
frame.set("maxNumber", l_maxNumber);
frame.set("classes", l_classes);
var t_2 = "";t_2 += "\r\n\t<div class=\"plusminusinput ";
t_2 += runtime.suppressValue(l_classes, env.opts.autoescape);
t_2 += "\">\r\n    <button class=\"minus\">-</button>\r\n      <input type=\"number\"\r\n        class=\"plusminusinput-input number Decimal\"\r\n        data-field-index=\"";
t_2 += runtime.suppressValue(l_index, env.opts.autoescape);
t_2 += "\"\r\n        value=\"";
t_2 += runtime.suppressValue(l_colval, env.opts.autoescape);
t_2 += "\"\r\n        ";
if(l_minNumber != runtime.contextOrFrameLookup(context, frame, "null")) {
t_2 += " \r\n          min=\"";
t_2 += runtime.suppressValue(l_minNumber, env.opts.autoescape);
t_2 += "\"\r\n        ";
;
}
t_2 += "\r\n        ";
if(l_maxNumber != runtime.contextOrFrameLookup(context, frame, "null")) {
t_2 += " \r\n          max=\"";
t_2 += runtime.suppressValue(l_maxNumber, env.opts.autoescape);
t_2 += "\"\r\n        ";
;
}
t_2 += "\r\n        ";
if(runtime.memberLookup((l_col),"MinNumber") != runtime.contextOrFrameLookup(context, frame, "null")) {
t_2 += " \r\n          min=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_col),"MinNumber"), env.opts.autoescape);
t_2 += "\"\r\n        ";
;
}
t_2 += "\r\n        ";
if(runtime.memberLookup((l_col),"MaxNumber") != runtime.contextOrFrameLookup(context, frame, "null")) {
t_2 += " \r\n          max=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_col),"MaxNumber"), env.opts.autoescape);
t_2 += "\"\r\n        ";
;
}
t_2 += "/>\r\n    <button class=\"plus\">+</button>\r\n  </div>";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("constructPlusMinusInput");
context.setVariable("constructPlusMinusInput", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/elements/plusminusinput.html"] , dependencies)